/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
// /////////////////////////////////////////////
// Helper   Ayudante
// /////////////////////////////////////////////

// * De Auth: los datos se recibirán del proveedor de autenticación
// const userDefaults = {
//   uid         : 0,          // From Auth
//   displayName : 'Sin nombre', // From Auth
//   about       : 'Postre tarta de chocolate gotas de limón azufaifas. Galleta magdalena helado oso garra brownie brownie malvavisco.',
//   photoURL    : require('@/assets/images/portrait/small/user-default.png'), // From Auth
//   status      : 'online',
//   userRole    : 'admin'
// }

// const userInfoLocalStorage = JSON.parse(localStorage.getItem('userInfo')) || {}

// Set default values for active-user // Establecer valores predeterminados para usuario activo
// More data can be added by auth provider or other plugins/packages  // El proveedor de autenticación u otros complementos / paquetes pueden agregar más datos
// const getUserInfo = () => {
//   const userInfo = {}

//   // Update property in user
//   Object.keys(userDefaults).forEach((key) => {
//     // If property is defined in localStorage => Use that
//     userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
//   })

//   // Include properties from localStorage
//   Object.keys(userInfoLocalStorage).forEach((key) => {
//     if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null) userInfo[key] = userInfoLocalStorage[key]
//   })

//   return userInfo
// }
// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
// const is_touch_device = () => {
//   const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
//   const mq = function (query) {
//     return window.matchMedia(query).matches
//   }

//   if ('ontouchstart' in window || window.DocumentTouch) {
//     return true
//   }

//   // include the 'heartz' as a way to have a non matching MQ to help terminate the join
//   // https://git.io/vznFH
//   const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
//   return mq(query)
// }
// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: []
  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
};

export default state;
